import type { TFunction } from 'i18next';

import { INCIDENT_CAUSE_TRANSLATION_KEY, UNKNOWN_CAUSE } from '@/utils/constants';

export const getTranslatedCause = (t: TFunction, cause?: string) => {
  if (!cause || cause === UNKNOWN_CAUSE) {
    return '';
  }

  const translationKey = INCIDENT_CAUSE_TRANSLATION_KEY[cause];

  return translationKey ? t(translationKey) : cause;
};
